export default __webpack_public_path__ + "static/media/property_388.2dc897cc.png";